<template>
  <span>
    <v-btn small icon @click="handleShowForm">
      <v-icon small>fa-code</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" full-width
              @keydown.esc="showModal = false">
      <v-card v-if="showModal">
        <v-card-title class="headline">
          <slot name="header">
            Data
          </slot>
        </v-card-title>
        <v-card-text>
          <vue-json-pretty :data="jsonData"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
    import VueJsonPretty from 'vue-json-pretty'

    export default {
        name: 'modal-json-view',
        components: {
            VueJsonPretty
        },
        props: {
            jsonData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            handleShowForm() {
                this.showModal = true
            },
            handleHideForm() {
                this.showModal = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/ModalJsonView.vue